import { useBreakpoints } from '../../hooks/useBreakpoints';
import Button from '../button/v2/button';
import { HStack } from '../layouts/stack.layout';
import Heading from '../typography/v2/heading';

type FormModalHeaderProps = {
  close: Function;
  title: string;
  button: {
    text: string;
    action: Function;
  };
};

export default function HeaderModal(props: FormModalHeaderProps) {
  const { isMobile, isTabletLg } = useBreakpoints();

  return (
    <HStack justify="between" extensions="w-full items-center">
      <HStack gap="base" extensions="items-center">
        <Button
          onClick={props.close}
          asIcon={isMobile && !isTabletLg ? 'back' : 'close'}
          withButtonStyle={isMobile && !isTabletLg ? true : false}
          color="glass"
          size="sm"
        />
        <Heading variant="secondary">{props.title}</Heading>
      </HStack>
      <Button size="sm" onClick={props.button.action}>
        {props.button.text}
      </Button>
    </HStack>
  );
}
